import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { EIntakeType } from "@rentiohq/shared-frontend/dist/types/broker.types";
import { EField, IExtraData } from "./schema.tenantProfileBroker.types";

export const getInitialValues = ({ broker }: IExtraData): IValues => {
  return {
    [EField.IntakeMail]: broker.intakeMail || undefined,
    // New accounts (no intake type set yet) default to the two-step flow with
    // waiting list & schedule-for-visit; existing accounts keep their choice.
    [EField.IntakeType]: broker.intakeType ?? EIntakeType.TwoPhasesWithVisit,
  };
};
